import { useAuth0 } from '@auth0/auth0-react';
import { openInNewTab } from '@strata/helper-functions';
import { Header as StrataHeader } from '@strata/react-header';

import { FeatureCarousel } from 'components/header/FeatureCarousel';
import { clearDataForLogout } from 'services/authHelpers';
import { AppRoutes } from 'services/routes';
import { useGetHomeScreenMessagesQuery } from 'store/api/announcementApi';

export const Header = () => {
    const { isAuthenticated, logout } = useAuth0();

    const navTabs = isAuthenticated
        ? [
              {
                  label: 'Claims',
                  to: AppRoutes.claims,
              },
          ]
        : [];

    // Load home screen messages & carousels on login
    useGetHomeScreenMessagesQuery(undefined, { skip: !isAuthenticated });

    const onLogOutClick = () => {
        (async () => {
            clearDataForLogout();
            await logout({
                logoutParams: { returnTo: `${window.location.origin}${AppRoutes.loggedOut}` },
            });
        })();
    };

    return (
        <>
            <StrataHeader
                navBar={navTabs}
                onLogOutClick={onLogOutClick}
                showProfileDropdown={isAuthenticated}
                onTermsOfUseClick={() => openInNewTab(AppRoutes.termsOfUse)}
                onPrivacyPolicyClick={() => openInNewTab(AppRoutes.privacyPolicy)}
                appVersion={process.env.REACT_APP_VERSION}
                fmhEnvironmentForTag={process.env.REACT_APP_ENV}
            />
            {isAuthenticated && <FeatureCarousel />}
        </>
    );
};
